import fp from 'lodash/fp';
import { minDonationAmount } from 'common/helpers/donation';

export function validateCartPerkLineItems({
    currency,
    totalAmount,
    perkLineItems,
    perkAmountProperty,
}) {
    const baseCurrencyAmountProperty =
        perkAmountProperty === 'amount'
            ? 'primaryCurrencyAmount'
            : 'primaryCurrencyRecurringAmount';

    const perkLineItemsWithUnspecifiedAmount = perkLineItems.filter(
        li => !li[baseCurrencyAmountProperty],
    );

    const minAmount = minDonationAmount(currency);

    const perkLineItemsErrors = perkLineItemsWithUnspecifiedAmount
        .filter(
            li =>
                !li[perkAmountProperty] ||
                (totalAmount < minAmount && li[perkAmountProperty] < minAmount),
        )
        .map(li => ({ perkId: li.perkId, error: 'invalidAmount' }));

    return fp.groupBy('perkId', perkLineItemsErrors);
}
